export const reduceObject = (obj: any, path: string, delimiter?: string) =>
  path
    .split(delimiter || '.')
    .reduce((reducedObj, currKey) => (reducedObj !== undefined ? reducedObj[currKey] : undefined), obj);
